<form [formGroup]="form" (ngSubmit)="save()">

  <!-- V2 Style - Floating Label -->
  <ng-container *ngIf="variant === 'v2'; else v3Style">
    <div class="form__group" [ngClass]="{'form__error': isSubmitted() && f[field.key].errors}">
      <div class="p-float-label">
        <p-inputMask [formControlName]="field.key" [mask]="country.phoneCountryMask" [autoClear]="false" slotChar="" (onBlur)="save()"></p-inputMask>
        <label>
          <ng-container *ngIf="field.key === 'telefono_alterno'; else defaultLabel">
            Número celular adicional con mensajería de texto activo *
          </ng-container>
          <ng-template #defaultLabel>{{ field.label }} *</ng-template>
        </label>
      </div>

      <span class="form__msgError" *ngIf="(isSubmitted() || f[field.key].touched) && f[field.key] && f[field.key].errors">
        <small class="p-error" *ngIf="f[field.key].hasError('required')">Requerido</small>
        <small class="p-error" *ngIf="f[field.key]?.hasError('duplicate')">Teléfono ya registrado*</small>
        <small class="p-error" *ngIf="f[field.key]?.hasError('invalid')">{{ "Teléfono" | invalid }}</small>
        <small class="p-error" *ngIf="f[field.key]?.hasError('mustMatch')">{{f[field.key]?.getError('mustMatch')}}</small>
        <small class="p-error" *ngIf="f[field.key]?.hasError('minlength')">Se requieren los {{ f[field.key].errors ? f[field.key].getError('minlength').requiredLength:0}} caracteres</small>
      </span>

      <span class="form__msgValidate" *ngIf="f[field.key].pending">
        <small class="p-validate">
          <i class="pi pi-spin pi-spinner"></i>
          <span>Validando teléfono...</span>
        </small>
      </span>
    </div>
  </ng-container>

  <!-- V3 Style - Static Label -->
  <ng-template #v3Style>
    <div class="form__group">
      <label class="form__label pb-5" [for]="field.key">{{ field.label }}</label>
      <p-inputMask
        [id]="field.key"
        [formControlName]="field.key"
        [mask]="country.phoneCountryMask"
        [autoClear]="false"
        slotChar=""
        (onBlur)="save()">
      </p-inputMask>

      <span class="form__msgError" *ngIf="(isSubmitted() || f[field.key].touched) && f[field.key] && f[field.key].errors">
        <small class="p-error" *ngIf="f[field.key].hasError('required')">Requerido</small>
        <small class="p-error" *ngIf="f[field.key]?.hasError('duplicate')">Teléfono ya registrado*</small>
        <small class="p-error" *ngIf="f[field.key]?.hasError('invalid')">{{ "Teléfono" | invalid }}</small>
        <small class="p-error" *ngIf="f[field.key]?.hasError('mustMatch')">{{f[field.key]?.getError('mustMatch')}}</small>
        <small class="p-error" *ngIf="f[field.key]?.hasError('minlength')">Se requieren los {{ f[field.key].errors ? f[field.key].getError('minlength').requiredLength:0}} caracteres</small>
      </span>

      <span class="form__msgValidate" *ngIf="f[field.key].pending">
        <small class="p-validate">
          <i class="pi pi-spin pi-spinner"></i>
          <span>Validando teléfono...</span>
        </small>
      </span>
    </div>
  </ng-template>

</form>
